import './Affliate.css';
import React, { useState, useEffect } from 'react';
// import './Dashboard.css';
import { Avatar, Box, Button, Grid2, Tab } from '@mui/material';
import Header from '../Header/Header';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import consts from "../../constant";
import Axios from "axios";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ToastContainer, toast } from "react-toastify";
import usercalls from "../../Axios";

const drawerWidth = 260;
const Affliate = () => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up('lg'));

    const Navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setloading] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPages] = useState(0)
    const itemsPerPage = 10

    const path = usercalls()

    const withdrawDetails = async () => {
        try {
            setloading(true);
            const url = `${consts.BackendUrl}/admin/getAffliateHistory`;
            const response = await path.postCall({ url });
            const result = await response.json();
            console.log(result, 'result');
            if (result?.success) {
                setData(result?.result);
                setloading(false);
                setTotalPages(Math.ceil(result?.result.length / limit));
            }
        } catch (error) {
            console.log(error, 'errors');
        }
    };

    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            withdrawDetails()
        } else {
            Navigate(`/${consts.route + '/login'}`);
        }
    }, [limit, page]);


    const [reason, setReason] = useState("")

    const [selcId, setSelcId] = useState("")

    const handleUpdate = async (val, type) => {
        console.log(val, type, "74545444444")
        try {

            let payload = {}
            if (type == "approved") {
                payload = {
                    id: val,
                    status: type,
                    reason: "Your withdraw is Approved by Admin",
                }
            } else {
                payload = {
                    id: val,
                    status: type,
                    reason: "Your withdraw is Rejected by Admin",
                }
            }

            const url = `${consts.BackendUrl}/wallet/updateWithdrawStatus`
            const response = await path.postCall({ url, payload })
            const result = await response.json()
            console.log(result, 'result');
            if (result?.success) {
                toast.success(result?.message)
                withdrawDetails()

            }
        } catch (error) {
            console.log("🚀 ~ handleUpdate ~ error:", error)
        }

    }






    const array = ["S.no", "Name", "Email", "Phone_number",
        "Social Media", "Company_Name", "Website_Url",
        "Audience_Followers", "Affiliate_Experience",
        "Primary_Interest", "Great_Affiliate", "Geographic_Location",
        "Payment_Method", "Promote_Tajir",
        "Action"
    ];

    return (
        <div className="UserWithdrawHistry">
            <ToastContainer />
            <Box sx={{ display: lg ? 'flex' : 'block' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
                >
                    <h2 style={{ color:"#fff", margin:'0' }}>Affiliate</h2>
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <div className="custom_table">
                                <TableContainer>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                {array.map((val, index) => (
                                                    <TableCell align="center" key={index}>
                                                        {val}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {data
                                                .slice((page - 1) * limit, page * limit)
                                                .map((value, index) => (
                                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell component="th" scope="row">
                                                            {limit * (page - 1) + index + 1}
                                                        </TableCell>
                                                        <TableCell align="center">{value?.your_name || '-'}</TableCell>
                                                        <TableCell align="center">{value?.email || '-'}</TableCell>
                                                        <TableCell align="center">{value?.phone_number || '-'}</TableCell>
                                                        <TableCell align="center">{value?.social_media || '-'}</TableCell>
                                                        <TableCell align="center">{value?.company_name || '-'}</TableCell>
                                                        <TableCell align="center">{value?.website_url || '-'}</TableCell>
                                                        <TableCell align="center">{value?.audience_followers || '-'}</TableCell>
                                                        <TableCell align="center">{value?.affiliate_experience || '-'}</TableCell>
                                                        <TableCell align="center">{value?.primary_interest || '-'}</TableCell>
                                                        <TableCell align="center">{value?.great_affiliate || '-'}</TableCell>
                                                        <TableCell align="center">{value?.geographic_location || '-'}</TableCell>
                                                        <TableCell align="center">{value?.payment_method || '-'}</TableCell>
                                                        <TableCell align="center">{value?.promote_tajir || '-'}</TableCell>
                                                        <TableCell align="center">
                                                            <Button
                                                                variant="contained"
                                                                color="success"
                                                                onClick={() => {
                                                                    Navigate(`/${consts.route}/affliateview`, {
                                                                        state: {
                                                                            value
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                View
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination
                                    className="pagnation"
                                    count={totalPage}
                                    page={page}
                                    onChange={(event, value) => {
                                        setPage(value);
                                    }}
                                    shape="rounded"
                                />
                            </div>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
        </div >
    );
};

export default Affliate;
